module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-call_green.d793fd38.svg";